/*
 * @Author: ljiangyun 396242451@qq.com
 * @Date: 2023-05-21 19:27:57
 * @LastEditors: ljiangyun 396242451@qq.com
 * @LastEditTime: 2024-08-21 09:54:04
 * @FilePath: /社区管理后台/src/utils/request.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from "axios";
import { Message, Loading } from "element-ui";

let loading;
const service = axios.create({
  baseURL: "https://community.gmfintl.com/",
  // baseURL: "/",
  timeout: 5000000,
});

service.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("bbsToken");
    if(config.url == '/app/contract/getTaskProgress'){

    }else{
      loading = Loading.service({
        lock: true,
        text: "",
        background: "rgba(0, 0, 0, 0.01)",
      });
    }
   
    // 如果 token 存在
    // 让每个请求携带自定义 token 请根据实际情况自行修改
    if (token) {
      config.headers.authorization = token;
    }
    return config;
  },
  (error) => {
    console.log(error);
    if (loading) {
      loading.close();
    }
    return Promise.reject();
  }
);

service.interceptors.response.use(
  (response) => {
    if (loading) {
      loading.close();
    }
    if (response.status === 200) {
      if (response.data.code != 200) {
        if (response.data.msg) {
          if (response.data.code == 401) {
            Message.error("登陆过期或未登录，正在跳转 请稍候...");
            setTimeout(() => {
              window.location.href =
                "https://community.gmfintl.com/app/saml2/login";
            }, 1500);
          } else if (response.data.code == 403) {
            Message.error("当前登陆用户无权限，正在跳转 请稍候...");
            setTimeout(() => {
              window.location.href =
                "https://community.gmfintl.com/app/saml2/login";
            }, 1500);
          } else {
            Message.error(response.data.msg);
          }
        }
      }
      return response.data;
    } else {
      Promise.reject();
    }
  },
  (error) => {
    if (loading) {
      loading.close();
    }
    console.log(error);
    return Promise.reject();
  }
);

export default service;
